import axios from 'utils/axios';
import { put } from 'redux-saga/effects';
import * as CompanyOnboarding from 'actions/CompanyOnboarding';

export function* onCreateCompanyRequest({ payload, cb }) {
	try {
		const data = new FormData();

		// Company
		payload.company.metadata.forEach(function (metadata) {
			data.append('metadatas', metadata.metadataId);
		});
		data.append('employed', payload.company.employees);
		data.append('revenue', payload.company.revenue);
		data.append('headQuarters', payload.company.headquarter);	
		data.append('founded', payload.company.founded);
		data.append('homepage', payload.company.homepage);
		data.append('companyLogo', payload.company.logo);

		// Payment
		data.append('licenseType', payload.payment.hitFunding);
		data.append('billingInfoFirstName', payload.payment.contactPersonFirstName);
		data.append('billingInfoLastName', payload.payment.contactPersonLastName);
		data.append('invoiceAddress', payload.payment.invoiceAdress);
		data.append('corporateIdentityNumber', payload.payment.corporateIdentityNumber);
		data.append('vat', payload.payment.vatNumber);

		const { data: rs } = yield axios.post(`/api/company/boarding`, data)		

		yield put(CompanyOnboarding.onCreateCompanySuccess(rs));
		
		cb && cb(rs);
	
	} catch (e) {
		yield put(CompanyOnboarding.onCreateCompanyFailure({ message: e.toString() }));
		cb && cb(e);       
	}
}

export function* onCreateCompanyUserRequest({ payload, cb }) {
	try {
		const data = new FormData();
		data.append('profilePicture', payload.about.picture);
		data.append('firstName', payload.about.firstName);
		data.append('lastName', payload.about.lastName);	
		data.append('email', payload.about.email);
		data.append('profession', payload.about.role);
		data.append('phone', payload.about.phone);
		data.append('aboutMe', payload.about.aboutMe);

		const { data: rs } = yield axios.post(`/api/companyUser/boarding`, data);
		
		yield put(CompanyOnboarding.onCreateCompanyUserSuccess(rs));
		
		cb && cb(rs);
	
	} catch (e) {
		yield put(CompanyOnboarding.onCreateCompanyUserFailure({ message: e.toString() }));
		cb && cb(e);       
	}
}